var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{attrs:{"show_delete_action":false,"show_edit_action":false,"show_select":true,"selected_item_ids":_vm.selected_ids,"items":_vm.users,"headers":_vm.headers},on:{"select_item_id":_vm.select_item_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }